import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { RotateCcw, X } from 'lucide-react';
import { leadsAPI } from '../services/api';

// A lead already in the pipeline submitted a new form
// (server/services/reengagement.js). Shown on Lead Detail and the Pipeline
// drawer; it goes away once someone acts on the lead, or with Dismiss.
const ReengagedNotice = ({ lead, className = '' }) => {
  const queryClient = useQueryClient();
  const dismiss = useMutation(() => leadsAPI.dismissReengaged(lead._id), {
    onSuccess: () => {
      queryClient.invalidateQueries(['lead', String(lead._id)]);
      // Pipeline board queries all start with 'pipeline' (see PipelineBoard).
      queryClient.invalidateQueries({ predicate: (q) => String(q.queryKey?.[0] || '').startsWith('pipeline') });
    },
    onError: (err) => toast.error(err.response?.data?.error || 'Could not dismiss'),
  });
  if (!lead?.reengagedAt) return null;
  const r = lead.reengaged || {};
  const when = new Date(lead.reengagedAt).toLocaleString();
  return (
    <div className={`flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900 ${className}`}>
      <RotateCcw size={14} className="mt-0.5 shrink-0 text-amber-600" />
      <span className="flex-1">
        {r.reopened ? 'Reopened: ' : 'Returning lead: '}
        submitted a new form on {when}
        {r.campaign ? ` (${r.campaign})` : ''}
        {r.reopened && r.fromStage ? `, moved back from "${r.fromStage}"` : ''}.
        {' '}Follow up while they're interested.
      </span>
      <button
        type="button"
        onClick={() => dismiss.mutate()}
        disabled={dismiss.isLoading}
        className="shrink-0 inline-flex items-center gap-0.5 text-amber-700 hover:text-amber-900 disabled:opacity-50"
        title="Hide this notice"
      >
        <X size={12} /> Dismiss
      </button>
    </div>
  );
};

export default ReengagedNotice;
